/* ===========================================================================
   wc-zoom — PDP full-screen image viewer
   ---------------------------------------------------------------------------
   Replaces Dawn's click-anywhere-on-the-photo modal with a deliberate
   magnifier control, and opens a real full-screen viewer: the carousel stays
   live inside it, images zoom and pan, and a close button returns to the PDP.

   Deliberately built as its own layer rather than by editing
   snippets/product-media-modal.liquid -- that modal is shared with quick-add
   and other surfaces, and Dawn's version has no zoom of its own.
   =========================================================================== */
(function () {
  'use strict';

  if (window.__wcZoomInit) return;
  window.__wcZoomInit = true;

  var IMG_WIDTH = 1946; /* matches the widths the gallery already requests, so
                           the CDN serves a cached render rather than a new one */
  var MAX_SCALE = 4;
  var MIN_SCALE = 1;
  var TAP_SLOP = 10; /* px of movement still counted as a tap, not a swipe */

  var ICON_ZOOM =
    '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="8.6" cy="8.6" r="5.6" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M12.8 12.8 L17.5 17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '<path d="M6.2 8.6h4.8M8.6 6.2v4.8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  var ICON_CLOSE =
    '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '</svg>';

  var ICON_ARROW =
    '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12.5 4L6.5 10l6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  /* ---------------------------------------------------------------------
     Trigger injection
     --------------------------------------------------------------------- */

  function galleries() {
    return document.querySelectorAll('media-gallery .product__media-list');
  }

  /* Build one trigger. `resolve` is called at click time and returns the
     media container to open -- deferred, because a locked trigger does not
     know which slide it sits over until the moment it is pressed. */
  function makeTrigger(resolve, extraClass) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wcz-trigger' + (extraClass ? ' ' + extraClass : '');
    btn.setAttribute('aria-label', 'Open full screen image viewer');
    btn.innerHTML = '<span class="wcz-trigger__pill">' + ICON_ZOOM + '</span>';

    /* The strip spans the full width so it is easy to hit, which means it also
       sits on top of the carousel's swipe area. Only fire when the pointer
       barely moved -- a drag belongs to the slider. */
    var sx = 0;
    var sy = 0;
    var moved = false;

    btn.addEventListener('pointerdown', function (e) {
      sx = e.clientX;
      sy = e.clientY;
      moved = false;
    });

    btn.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - sx) > TAP_SLOP || Math.abs(e.clientY - sy) > TAP_SLOP) {
        moved = true;
      }
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (moved) return;
      var target = resolve();
      if (target) open(target);
    });

    return btn;
  }

  /* Is this gallery actually a horizontal carousel right now? Mobile is;
     the stacked desktop layout is not. The answer decides where the trigger
     mounts, and it changes on resize. */
  function isCarousel(list) {
    return list.scrollWidth > list.clientWidth + 8;
  }

  /* Which slide is under the locked trigger. Hidden slides are display:none,
     so they take up no scroll width -- index against the visible ones. */
  function currentContainer(list) {
    var visible = [];
    list.querySelectorAll('li.product__media-item').forEach(function (li) {
      if (!li.classList.contains('hide-image')) visible.push(li);
    });
    if (!visible.length) return null;
    var w = list.clientWidth || 1;
    var i = Math.round(list.scrollLeft / w);
    i = Math.min(visible.length - 1, Math.max(0, i));
    var li = visible[i];
    return li ? li.querySelector('.product-media-container.media-type-image') : null;
  }

  /* The slider viewport is the positioning context, but it also contains the
     prev/next/counter row beneath the images. Sit the strip on the bottom edge
     of the image area itself, measured rather than guessed, so it lands in the
     same place whether or not those controls are showing. */
  function placeLocked(host, list, btn) {
    var h = btn.offsetHeight || 56;
    btn.style.left = list.offsetLeft + 'px';
    btn.style.width = list.clientWidth + 'px';
    btn.style.top = list.offsetTop + list.clientHeight - h + 'px';
  }

  function addTriggers() {
    galleries().forEach(function (list) {
      var host = list.closest('slider-component') || list.parentElement;
      if (!host) return;

      if (isCarousel(list)) {
        /* Carousel: ONE trigger anchored to the viewport, not to a slide.
           Mounted per-slide it scrolled away with the image it was on. */
        list
          .querySelectorAll('.wcz-trigger')
          .forEach(function (old) { old.remove(); });

        host.classList.add('wcz-host');
        var locked = host.querySelector(':scope > .wcz-trigger');
        if (!locked) {
          locked = makeTrigger(function () { return currentContainer(list); }, 'wcz-trigger--locked');
          host.appendChild(locked);
        }
        placeLocked(host, list, locked);
        return;
      }

      /* Stacked layout: nothing scrolls, so a trigger per image is correct. */
      host.classList.remove('wcz-host');
      var stale = host.querySelector(':scope > .wcz-trigger');
      if (stale) stale.remove();

      list
        .querySelectorAll('.product-media-container.media-type-image')
        .forEach(function (container) {
          if (container.querySelector('.wcz-trigger')) return;
          container.appendChild(
            makeTrigger(function () { return container; })
          );
        });
    });
  }

  /* ---------------------------------------------------------------------
     Collecting the slides that are actually on show
     --------------------------------------------------------------------- */

  function bigSrc(img) {
    var src = img.currentSrc || img.src || '';
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1' + IMG_WIDTH);
    return src;
  }

  /* Only the media for the colour the customer is looking at. The gallery
     hides the rest with .hide-image rather than removing them, so read the
     live DOM every time the viewer opens -- never cache this. */
  function collect(container) {
    var list = container.closest('.product__media-list');
    var out = [];
    var startIndex = 0;
    if (!list) return { items: out, index: 0 };

    var slides = list.querySelectorAll('li.product__media-item');
    slides.forEach(function (li) {
      if (li.classList.contains('hide-image')) return;
      var box = li.querySelector('.product-media-container');
      if (!box || !box.classList.contains('media-type-image')) return;
      var img = box.querySelector('.product__media img');
      if (!img) return;
      if (box === container) startIndex = out.length;
      out.push({ src: bigSrc(img), alt: img.getAttribute('alt') || '' });
    });

    return { items: out, index: startIndex };
  }

  /* ---------------------------------------------------------------------
     The viewer
     --------------------------------------------------------------------- */

  var el = null;
  var state = { index: 0, count: 0, scale: 1, x: 0, y: 0, open: false, scrollY: 0 };

  function build() {
    if (el) return el;

    el = document.createElement('div');
    el.className = 'wcz';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product image viewer');
    el.hidden = true;
    el.innerHTML =
      '<div class="wcz__bar">' +
      '<span class="wcz__count"><b>1</b> / <i>1</i></span>' +
      '<button type="button" class="wcz__close" aria-label="Close viewer">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="wcz__track"></div>' +
      '<button type="button" class="wcz__nav wcz__nav--prev" aria-label="Previous image">' + ICON_ARROW + '</button>' +
      '<button type="button" class="wcz__nav wcz__nav--next" aria-label="Next image">' + ICON_ARROW + '</button>' +
      '<div class="wcz__tools">' +
      '<button type="button" data-wcz="out" aria-label="Zoom out">&minus;</button>' +
      '<button type="button" data-wcz="reset">100%</button>' +
      '<button type="button" data-wcz="in" aria-label="Zoom in">+</button>' +
      '</div>';

    document.body.appendChild(el);

    var track = el.querySelector('.wcz__track');

    el.querySelector('.wcz__close').addEventListener('click', close);
    el.querySelector('.wcz__nav--prev').addEventListener('click', function () { go(-1); });
    el.querySelector('.wcz__nav--next').addEventListener('click', function () { go(1); });
    el.querySelector('.wcz__nav--next').style.transform = 'translateY(-50%) rotate(180deg)';

    el.querySelectorAll('[data-wcz]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-wcz');
        if (k === 'in') setScale(state.scale + 0.5);
        else if (k === 'out') setScale(state.scale - 0.5);
        else setScale(1);
      });
    });

    track.addEventListener('scroll', function () {
      if (state.scale > 1) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== state.index) {
        state.index = i;
        paintCount();
      }
    });

    bindGestures(track);
    return el;
  }

  function slides() {
    return el ? el.querySelectorAll('.wcz__slide') : [];
  }

  function activeSlide() {
    return slides()[state.index] || null;
  }

  function paintCount() {
    if (!el) return;
    el.querySelector('.wcz__count b').textContent = String(state.index + 1);
    el.querySelector('.wcz__count i').textContent = String(state.count);
  }

  function applyTransform() {
    var s = activeSlide();
    if (!s) return;
    var img = s.querySelector('img');
    if (!img) return;
    img.style.transform =
      'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
    s.classList.toggle('is-scaled', state.scale > 1);
    el.classList.toggle('is-zoomed', state.scale > 1);
    el.querySelector('[data-wcz="reset"]').textContent = Math.round(state.scale * 100) + '%';
    el.querySelector('[data-wcz="out"]').disabled = state.scale <= MIN_SCALE;
    el.querySelector('[data-wcz="in"]').disabled = state.scale >= MAX_SCALE;
  }

  function setScale(next) {
    var was = state.scale;
    state.scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, next));
    if (state.scale === 1) {
      state.x = 0;
      state.y = 0;
    }
    applyTransform();

    /* Coming back to 1x hands the drag back to the carousel. Re-seat the
       scroll position, because the track was overflow:hidden while zoomed. */
    if (was > 1 && state.scale === 1) {
      var track = el.querySelector('.wcz__track');
      track.scrollLeft = state.index * track.clientWidth;
    }
  }

  function go(step) {
    if (state.scale > 1) setScale(1);
    var next = Math.min(state.count - 1, Math.max(0, state.index + step));
    var track = el.querySelector('.wcz__track');
    track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
    state.index = next;
    paintCount();
  }

  /* --- pinch, drag-to-pan, double-tap ------------------------------------ */
  function bindGestures(track) {
    var pts = {};
    var pinchStart = 0;
    var scaleStart = 1;
    var panFrom = null;
    var lastTap = 0;

    track.addEventListener('pointerdown', function (e) {
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);

      if (ids.length === 2) {
        pinchStart = dist(pts[ids[0]], pts[ids[1]]);
        scaleStart = state.scale;
      } else if (ids.length === 1 && state.scale > 1) {
        panFrom = { x: e.clientX, y: e.clientY, ox: state.x, oy: state.y };
        var s = activeSlide();
        if (s) s.classList.add('is-panning');
        track.setPointerCapture(e.pointerId);
      }
    });

    track.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);

      if (ids.length === 2 && pinchStart > 0) {
        e.preventDefault();
        var d = dist(pts[ids[0]], pts[ids[1]]);
        setScale(scaleStart * (d / pinchStart));
        return;
      }

      if (panFrom && state.scale > 1) {
        e.preventDefault();
        state.x = panFrom.ox + (e.clientX - panFrom.x);
        state.y = panFrom.oy + (e.clientY - panFrom.y);
        clampPan();
        applyTransform();
      }
    });

    function release(e) {
      delete pts[e.pointerId];
      if (Object.keys(pts).length < 2) pinchStart = 0;
      if (panFrom) {
        panFrom = null;
        var s = activeSlide();
        if (s) s.classList.remove('is-panning');
      }
    }

    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);

    /* Double-tap / double-click toggles between fit and 2x.
       A single click does nothing on purpose: closing on a stray tap is the
       same class of bug we just removed from the PDP gallery. The cross is
       the way out. */
    track.addEventListener('click', function () {
      var now = Date.now();
      if (now - lastTap < 300) {
        setScale(state.scale > 1 ? 1 : 2);
        lastTap = 0;
      } else {
        lastTap = now;
      }
    });

    track.addEventListener(
      'wheel',
      function (e) {
        if (!e.ctrlKey && state.scale === 1) return;
        e.preventDefault();
        setScale(state.scale - e.deltaY * 0.003);
      },
      { passive: false }
    );
  }

  function clampPan() {
    var s = activeSlide();
    if (!s) return;
    var img = s.querySelector('img');
    if (!img) return;
    var slack = state.scale - 1;
    var maxX = (img.clientWidth * slack) / 2;
    var maxY = (img.clientHeight * slack) / 2;
    state.x = Math.min(maxX, Math.max(-maxX, state.x));
    state.y = Math.min(maxY, Math.max(-maxY, state.y));
  }

  function dist(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  /* --- open / close ------------------------------------------------------ */

  function open(container) {
    var data = collect(container);
    if (!data.items.length) return;

    build();
    var track = el.querySelector('.wcz__track');
    track.innerHTML = data.items
      .map(function (it) {
        return (
          '<div class="wcz__slide"><img src="' +
          it.src.replace(/"/g, '&quot;') +
          '" alt="' +
          it.alt.replace(/"/g, '&quot;') +
          '" draggable="false"></div>'
        );
      })
      .join('');

    state.index = data.index;
    state.count = data.items.length;
    state.scale = 1;
    state.x = 0;
    state.y = 0;
    state.open = true;
    state.scrollY = window.scrollY;

    el.classList.toggle('is-single', state.count < 2);
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    /* Wait a frame so the track has a measurable width before seating it on
       the image the customer actually pressed. */
    requestAnimationFrame(function () {
      track.scrollLeft = state.index * track.clientWidth;
      el.classList.add('is-open');
      paintCount();
      applyTransform();
      var closeBtn = el.querySelector('.wcz__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!el || !state.open) return;
    state.open = false;
    state.scale = 1;
    el.classList.remove('is-open', 'is-zoomed');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(function () {
      if (state.open) return;
      el.hidden = true;
      el.querySelector('.wcz__track').innerHTML = '';
    }, 190);
  }

  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.stopPropagation();
      close();
    } else if (e.key === 'ArrowRight') {
      go(1);
    } else if (e.key === 'ArrowLeft') {
      go(-1);
    } else if (e.key === '+' || e.key === '=') {
      setScale(state.scale + 0.5);
    } else if (e.key === '-') {
      setScale(state.scale - 0.5);
    }
  });

  /* ---------------------------------------------------------------------
     Boot. The gallery re-renders on variant change, so watch for new
     containers rather than binding once.
     --------------------------------------------------------------------- */

  function boot() {
    addTriggers();

    var host = document.querySelector('media-gallery');
    if (!host || host.__wczWatched) return;
    host.__wczWatched = true;

    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(addTriggers, 80);
    }).observe(host, { childList: true, subtree: true });

    /* Crossing the breakpoint swaps a carousel for a stacked grid and back,
       so the trigger has to be re-sited, not just repositioned. */
    var rz = null;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(addTriggers, 150);
    });

    /* Images arriving late change scrollWidth, which is what isCarousel()
       reads -- re-check once the gallery has settled. */
    window.addEventListener('load', function () { setTimeout(addTriggers, 100); });
    setTimeout(addTriggers, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 60);
  });
})();
